import type { Block } from "@/lib/marketing/first-aid-calculator/calculator";
import { SOURCE_URLS } from "@/lib/marketing/first-aid-calculator/sources";

/**
 * One block of the first aid needs calculator's result: a heading and its
 * lines, each linked to the regulation or HSE guidance it comes from. Shared
 * by the interactive result and the page's "every outcome" section, so both
 * always print the same words.
 */
export function FirstAidBlock({ block, headingLevel = 3 }: { block: Block; headingLevel?: 3 | 4 }) {
  const Heading = headingLevel === 3 ? "h3" : "h4";
  return (
    <div data-testid={`first-aid-block-${block.id}`}>
      <Heading className="text-base font-bold text-gray-900">{block.heading}</Heading>
      <ul className="mt-2 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-gray-700">
        {block.lines.map((line) => (
          <li key={line.text}>
            {line.text}{" "}
            <a
              href={SOURCE_URLS[line.source]}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-brand-700 underline hover:text-accent-dark"
            >
              ({line.cite})
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
